import { actionNameGenerator } from "../../utils/commonUtil";

const domainPrefix = "zip";
const zipActionNameGenerator = actionNameGenerator(domainPrefix);

export const fetchZipcodeDataType = zipActionNameGenerator("fetchZipcodeData");
export const resetZipCodeDataType = zipActionNameGenerator("resetZipCodeData");
export const resetAllZipFielsType = zipActionNameGenerator("resetAllZipFiels");
export const flushZipcodeFieldType = zipActionNameGenerator("flushZipcodeField");
export const zipcodeDataLoadingType = zipActionNameGenerator("zipcodeDataLoading");
export const zipcodeDataType = zipActionNameGenerator("zipcodeData");
export const cityFieldDataType = zipActionNameGenerator("cityFieldData");
